interface CalendarDayIconProps {
  /** Day of month to render inside the calendar body (1–31). */
  day: number
  size?: string
  color?: string
}

/**
 * Calendar glyph with the given day number drawn live inside its body.
 * Hand-written (not a `.svg?react`) because the digit is dynamic geometry —
 * see rule §13: the `.tsx` exception is for icons carrying logic svgr can't
 * generate. One component replaces what would otherwise be 31 static assets.
 */
export default function CalendarDayIcon({
  day,
  size = '24px',
  color = 'currentColor',
}: CalendarDayIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 -960 960 960'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'>
      <path d='M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-40q0-17 11.5-28.5T280-880q17 0 28.5 11.5T320-840v40h320v-40q0-17 11.5-28.5T680-880q17 0 28.5 11.5T720-840v40h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Z' />
      <text
        x='480'
        y='-360'
        textAnchor='middle'
        dominantBaseline='central'
        fontSize='340'
        fontWeight='700'
        fill={color}>
        {day}
      </text>
    </svg>
  )
}
